import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { Idle } from './idle';

const MAX_CONTENT_AGE_HOURS = 1;

interface AutoRefetchOptions {
  client: ApolloClient<NormalizedCacheObject>;
}

let lastRefetch: number | null = null;

/**
 * Autom. refetches all Queries when the user is idle
 * and the content is older than the given time.
 */
export function autoRefetchWhenInactive({ client }: AutoRefetchOptions) {
  lastRefetch = Date.now();

  function onTryRefresh() {
    if (lastRefetch === null) return;
    const timeDiff = Date.now() - lastRefetch;
    if (timeDiff >= MAX_CONTENT_AGE_HOURS * 3600 * 1000) {
      console.log(
        `[AUTO REFETCH] Refetching all queries, content is ${timeDiff / 1000} seconds old.`
      );
      lastRefetch = Date.now();
      client.resetStore();
      return;
    }
  }

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      // Refreshes the data when the user comes back to the page
      onTryRefresh();
    }
  });

  function refreshAfterTimeWhenIdle() {
    const IDLE_TIMEOUT = 120;

    setTimeout(() => {
      // This waits for an idle moment and then refreshes the data
      const idle = new Idle({
        activityReportInSec: IDLE_TIMEOUT,
        onReportUserIsIdle: () => {
          idle.dispose();
          onTryRefresh();
          refreshAfterTimeWhenIdle();
        },
      });
    }, MAX_CONTENT_AGE_HOURS * 3600 * 1000);
  }

  refreshAfterTimeWhenIdle();
}
